import {
  API_BASE_URL,
  API_MAJOR_VERSION,
  API_MINOR_VERSION,
  API_PROVIDER
} from "@user/constant.js";
import { getJSON, postJSON } from "lib/myAjax";
import humps from "humps";
import * as alert from "lib/alert";
import moment from "moment";
import Rollbar from "lib/rollbar";
import { charge } from "@/lib/booking/partialCharge.js";
import { getDistanceToRestaurant } from "@/lib/googleMapPlaceParser.js";
import { isEmpty, sortBy, omitBy, isNil } from "lodash-es";

const BIG_GROUP_STEP = "bigGroup";
const queryString = require("query-string");

export default {
  selectPackage({ state, getters, commit, dispatch }, payload) {
    commit("setStateProperty", {
      state: "reservation",
      property: "selectedPackages",
      value: payload
    });
    let step = 0;
    if (getters.selectedPackageAcceptManyQuantity) {
      step = 3.5;
    } else {
      step = 4;
    }
    dispatch("changeStep", {
      step
    });
  },
  selectBigGroupPackage({ state }, payload) {
    state.reservation.selectedPackages = payload;
  },
  getRestaurantData(ctx) {
    const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurants/${ctx.state.restaurant.id}.json`;
    return new Promise((resolve, reject) => {
      getJSON(
        url,
        r => {
          const response = humps.camelizeKeys(r);

          if (response.data) {
            ctx.commit("setState", {
              name: "restaurant",
              value: response.data
            });
            resolve(response);
          } else {
            reject();
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getUserData(ctx) {
    const provider = API_PROVIDER;
    const accessToken = ctx.rootState.token;
    const minorVersion = API_MINOR_VERSION;
    const payload = queryString.stringify(
      humps.decamelizeKeys({
        accessToken,
        provider,
        minorVersion
      })
    );
    const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/users.json/?${payload}`;
    return new Promise((resolve, reject) => {
      getJSON(
        url,
        r => {
          const response = humps.camelizeKeys(r);

          if (response.data) {
            resolve(response);
          } else {
            reject();
          }
        },
        error => {
          reject(error);
        }
      );
    });
  },
  changeStep(ctx, payload) {
    const step = payload.step;

    ctx
      .dispatch("beforeStepChange", {
        step: step
      })
      .then(() => {
        let newUrl = "";
        ctx.state.step = step;
        const searchParam = queryString.parse(window.location.search);
        searchParam.step = ctx.state.step;
        newUrl = "?" + queryString.stringify(searchParam);
        // history api
        window.history.pushState(
          { step: ctx.state.step },
          `step ${ctx.state.step}`,
          newUrl
        );
        ctx.dispatch("afterStepChange");
      })
      .catch(err => {
        alert.error(err, {
          layout: "topRight"
        });
      });
  },
  beforeStepChange(ctx, payload) {
    return new Promise((resolve, reject) => {
      const nextStep = payload.step;
      const { reservation } = ctx.state;
      const { restaurantAttr } = ctx.getters;
      // user go to big group form
      if (nextStep === BIG_GROUP_STEP) {
        resolve();
      } else {
        // user back to previous step
        if (nextStep < ctx.state.step) {
          if (nextStep === 0) {
            // check if url contain delivery == true, if yes force back to date panel
            const searchParam = queryString.parse(window.location.search);
            if (!!searchParam.delivery && searchParam.delivery === "true") {
              ctx.dispatch("forceSetAdultKids");
              ctx.dispatch("changeStep", 1);
              return;
            }
            // else, allow user back to number panel
            else {
              reservation.adult = 0;
              reservation.kids = 0;
              reservation.startTime = "";
              reservation.date = "";
              reservation.selectedPackages = [];
              reservation.formatedDate = "";
              resolve();
            }
          } else if (nextStep === 1) {
            reservation.date = "";
            reservation.formatedDate = "";
            reservation.startTime = "";
            reservation.selectedPackages = [];
            ctx.state.timePanel = "";

            resolve();
          } else if (nextStep === 2) {
            reservation.startTime = "";
            reservation.selectedPackages = [];

            resolve();
          } else if (nextStep === 3) {
            reservation.selectedPackages = [];
            resolve();
          } else if (nextStep === 3.5) {
            resolve();
          }
        }
        // user proceed to next step
        else {
          if (nextStep == 0) {
            resolve();
          } else if (nextStep == 1) {
            reservation.adult === 0
              ? reject("Select pack size first")
              : resolve();
          } else if (nextStep == 2) {
            reservation.date === "" ? reject("Select date first") : resolve();
          } else if (nextStep == 3) {
            reservation.startTime === ""
              ? reject("Select time first")
              : resolve();
          } else if (nextStep === 3.5) {
            if (isEmpty(ctx.getters.selectedPackagesDetail)) {
              reject("please select package");
            } else {
              resolve();
            }
          } else if (nextStep == 4) {
            if (ctx.getters.restaurantReservationSystemOnly) {
              reservation.startTime === ""
                ? reject("Select time first")
                : resolve();
            } else {
              isEmpty(reservation.selectedPackages)
                ? reject("Select package first")
                : resolve();
            }
          }
        }
      }
    });
  },
  afterStepChange(ctx) {
    ctx.state.isBigGroupBooking = false;

    if (ctx.state.step === 0) {
    } else if (ctx.state.step === 1) {
      ctx.dispatch("fetchAvailableDate");
    } else if (ctx.state.step === 2) {
      ctx.dispatch("fetchAvailableTime");
    } else if (ctx.state.step === 3) {
      ctx.dispatch("fetchPackages").catch(() => {});
    } else if (ctx.state.step === 4) {
      if (ctx.getters.isPartialCharge) {
        try {
          const payload = {
            adult: ctx.state.reservation.adult,
            kids: ctx.state.reservation.kids,
            restaurantId: ctx.state.restaurant.id,
            packages: ctx.state.reservation.selectedPackages
          };
          ctx
            .dispatch("calculatePartialCharge", payload)
            .then(() => {
              if (ctx.getters.isDineIn === false) {
                ctx.dispatch("forceSetAdultKids");
                ctx.dispatch("setSpecialOccassion");
              }
            })
            .catch(err => {
              Rollbar.error(err);
            });
        } catch (err) {
          Rollbar.error(err);
        }
      }
      if (ctx.getters.isDineIn === true) {
        ctx.dispatch("fetchSpecialOccasion");
      }
    } else if (ctx.state.step === BIG_GROUP_STEP) {
      ctx.state.isBigGroupBooking = true;
    }
  },
  fetchAvailableDate(ctx) {
    ctx.state.isLoading = true;
    const isDinein = ctx.state.userDineInMethod === "dine in" ? true : false;
    const forDelivery = isDinein ? false : true;
    const payload = queryString.stringify(
      humps.decamelizeKeys({
        adult: ctx.state.reservation.adult,
        kids: ctx.state.reservation.kids,
        minorVersion: "3",
        dineIn: isDinein,
        forDelivery
      })
    );
    const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurants/${ctx.state.restaurant.id}/find_available_dates.json?${payload}`;
    getJSON(
      url,
      r => {
        const response = r;
        const responseData = response.data;
        if (responseData) {
          // check disabled dates from API
          ctx.state.disabledDate.dates = responseData
            .filter(item => {
              return item.availability === false;
            })
            .map(item => {
              let splitDate = item.date.split("-");
              let formatedDate = new Date(
                splitDate[0],
                splitDate[1] - 1,
                splitDate[2]
              );
              return formatedDate;
            });
          // check if all dates are disabled
          if (ctx.state.disabledDate.dates.length == responseData.length) {
            Rollbar.info("No Available Dates Found");
            ctx.commit("setState", {
              name: "anyAvailableDate",
              value: false
            });
          } else {
            ctx.commit("setState", {
              name: "anyAvailableDate",
              value: true
            });
            // disabled all day before first date that get from API
            const startDate = moment(responseData[0].date);
            ctx.state.disabledDate.to = moment(startDate).toDate();
            // disabled all day that after last day that get from API
            const endDate = moment(responseData[responseData.length - 1].date);
            ctx.state.disabledDate.from = moment(endDate)
              .add(1, "days")
              .toDate();
          }
          ctx.state.isLoading = false;
        } else {
          alert.error("No Available Dates Found");
          Rollbar.info("No Available Dates Found");
          ctx.commit("setState", {
            name: "anyAvailableDate",
            value: false
          });
          ctx.state.isLoading = false;
        }
      },
      error => {
        Rollbar.error("failed load available date", {
          error
        });
        alert.error(error.message);
        ctx.state.isLoading = false;
      }
    );
  },
  fetchAvailableTime(ctx) {
    ctx.state.isLoading = true;
    const { adult, date } = ctx.state.reservation;
    const selectedDate = moment(date).format("YYYY-MM-DD");
    const isDinein = ctx.state.userDineInMethod === "dine in" ? true : false;
    const forDelivery = isDinein ? false : true;

    const payload = queryString.stringify(
      humps.decamelizeKeys({
        date: selectedDate,
        adult,
        kids: 0,
        minorVersion: "3",
        dineIn: isDinein,
        forDelivery
      })
    );
    const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurants/${ctx.state.restaurant.id}/find_available_start_times.json?${payload}`;
    getJSON(
      url,
      r => {
        ctx.state.isLoading = false;
        const response = r;
        if (response.data) {
          ctx.state.timePanel = response.data.sort();
        } else {
          ctx.state.timePanel = [];
          alert.error("No available time on selected date");
        }
        ctx.state.isLoading = false;
      },
      error => {
        Rollbar.error("failed load available time option", {
          error
        });
        alert.error(error.message);
        ctx.state.isLoading = false;
      }
    );
  },
  fetchPackages(ctx) {
    const errorMsg =
      "Ops, something went wrong, failed load available packages";
    try {
      ctx.state.isLoading = true;
      const { id } = ctx.state.restaurant;
      const { date, startTime, adult } = ctx.state.reservation;
      const isDinein = ctx.state.userDineInMethod === "dine in" ? true : false;
      const forDelivery = isDinein ? false : true;
      const datePayload = () => {
        if (moment(date).isValid()) {
          return moment(date).format("YYYY-MM-DD");
        } else {
          // if user's date is invalid, force redirect back to date panel
          ctx.dispatch("changeStep", { step: 1 });
          alert.error("Sorry something went wrong, please select date again");
          return;
        }
      };
      const payload = queryString.stringify(
        humps.decamelizeKeys({
          restaurantId: id,
          date: datePayload(),
          startTime: startTime,
          adult: adult,
          kids: 0,
          minorVersion: "website-v0",
          locale: window.appConfig.locale,
          dineIn: isDinein,
          forDelivery
        })
      );
      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurant_packages/check_availability.json?${payload}`;
      return new Promise((resolve, reject) => {
        getJSON(
          url,
          r => {
            const response = humps.camelizeKeys(r);
            if (response.data.length) {
              ctx.state.allPackages = sortBy(response.data, [
                "attributes.rankInRestaurantScope"
              ]);
            } else {
              ctx.state.allPackages = [];
              alert.error("No available packages");
            }
            ctx.state.isLoading = false;
            resolve();
          },
          error => {
            Rollbar.error(errorMsg, error);
            alert.error(error.message);
            ctx.state.isLoading = false;
            reject(errorMsg);
          }
        );
      });
    } catch (err) {
      alert.error(errorMsg);
      Rollbar.error(errorMsg, err);
    }
  },
  fetchBigGroupPackage(ctx) {
    return new Promise((resolve, reject) => {
      const payload = queryString.stringify(
        humps.decamelizeKeys({
          restaurantId: ctx.state.restaurant.id,
          bigGroup: true
        })
      );
      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/restaurant_packages/check_availability.json?${payload}`;
      return getJSON(
        url,
        r => {
          const response = humps.camelizeKeys(r);
          if (response.data.length) {
            ctx.state.allPackages = sortBy(response.data, [
              "attributes.typeCode"
            ]);
            resolve();
          } else {
            ctx.state.allPackages = [];
            alert.error("No available packages");
            reject();
          }
        },
        error => {
          Rollbar.error("failed load available packages", {
            error
          });
          alert.error(error.message);
          reject();
        }
      );
    });
  },
  fetchSpecialOccasion(ctx) {
    const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/dining_occasions.json`;
    getJSON(
      url,
      r => {
        const response = humps.camelizeKeys(r);
        if (response.data.length) {
          ctx.state.occasionList = response.data;
        } else {
          Rollbar.error("No special occasion data found", { response });
          alert.error("No special occasion data found");
        }
      },
      error => {
        Rollbar.error("failed load special occasion", {
          error
        });
        alert.error("Failed to load special occasion");
      }
    );
  },
  setDefaultUserAddress(ctx) {
    try {
      return new Promise(resolve => {
        const localData = localStorage.getItem("hungryhub_address_suggestion");
        if (ctx.state.userSignedIn) {
          if (localData) {
            const lastAddress = JSON.parse(localData);
            ctx.state.address.placeName = lastAddress.placeName;
            ctx.state.address.detail = lastAddress.detail;
            ctx.state.address.lat = lastAddress.lat;
            ctx.state.address.lon = lastAddress.lng || lastAddress.lon;
            resolve();
          } else {
            ctx.dispatch("fetchUserAddress").then(location => {
              const arrayOfLocation = location;
              if (arrayOfLocation.length > 0) {
                const lastAddress = arrayOfLocation[0].attributes;
                ctx.state.address.placeName = lastAddress.placeName;
                ctx.state.address.detail = lastAddress.detail;
                ctx.state.address.lat = lastAddress.lat;
                ctx.state.address.lon = lastAddress.lng || lastAddress.lon;
              }
              resolve();
            });
          }
        } else {
          if (localData) {
            const lastAddress = JSON.parse(localData);
            ctx.state.address.placeName = lastAddress.placeName;
            ctx.state.address.detail = lastAddress.detail;
            ctx.state.address.lat = lastAddress.lat;
            ctx.state.address.lon = lastAddress.lng || lastAddress.lon;
          }
          resolve();
        }
      });
    } catch (err) {
      Rollbar.error(err);
    }
  },
  fetchDistanceToRestaurant(ctx, payload) {
    return new Promise((resolve, reject) => {
      getDistanceToRestaurant(payload)
        .then(distance => {
          ctx.state.distanceToRestaurant = distance;
          resolve();
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchUserAddress(ctx) {
    return new Promise((resolve, reject) => {
      const userId = ctx.state.user.id;
      const accessToken = ctx.rootState.token;
      const payload = queryString.stringify(
        humps.decamelizeKeys({
          accessToken
        })
      );
      const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/users/${userId}/addresses.json?${payload}`;
      getJSON(
        url,
        r => {
          const response = humps.camelizeKeys(r);
          resolve(response.data);
        },
        error => {
          Rollbar.error("Cannot get last used address", {
            error
          });
          alert.error("Cannot get last used address");
          reject();
        }
      );
    });
  },
  setSpecialOccassion(ctx) {
    ctx.state.occasionList = [];
    const deliveryFee = parseInt(
      ctx.state.reservation.partialCharge.data.deliveryFee
    );
    const selfPickUp = {
      id: "pick_up",
      type: "dining_occasion",
      attributes: {
        name: "Self-Pickup"
      }
    };
    const delivery = {
      id: "delivery",
      type: "dining_occasion",
      attributes: {
        name: `Delivery`,
        value: deliveryFee > 0 ? deliveryFee : null
      }
    };
    const deliveryType = ctx.getters.selectedPackageDeliveryType;
    if (deliveryType === "self_pickup_and_delivery") {
      ctx.state.occasionList.push(selfPickUp);
      ctx.state.occasionList.push(delivery);
    } else if (deliveryType === "delivery") {
      ctx.state.occasionList.push(delivery);
    } else if (deliveryType === "self_pickup") {
      ctx.state.occasionList.push(selfPickUp);
    } else {
      ctx.state.occasionList.push(selfPickUp);
      ctx.state.occasionList.push(delivery);
    }
  },
  forceSetAdultKids(ctx) {
    ctx.state.reservation.adult = 1;
    ctx.state.reservation.kids = 0;
  },
  calculatePartialCharge({ state }, payload) {
    return new Promise((resolve, reject) => {
      try {
        let param = {};
        if (payload.guess) {
          param = {
            distance: payload.distance / 1000,
            guess: true
          };
        } else {
          param = {
            adult: payload.adult,
            kids: payload.kids,
            restaurantId: payload.restaurantId,
            packages: payload.packages || []
          };
          // if user select delivery and get delivery address
          if (state.address.detail) {
            param.distance = state.distanceToRestaurant.value / 1000;
          }
        }
        charge(param)
          .then(result => {
            state.reservation.partialCharge = result;

            resolve();
          })
          .catch(err => {
            state.reservation.partialCharge = {
              data: null,
              status: false,
              message: err
            };
            alert.error(err, {
              layout: "topRight"
            });
            Rollbar.error(err, param);
            reject(err);
          });
      } catch (err) {
        Rollbar.error(err);
      }
    });
  },
  createBooking({ state, getters, rootGetters }, channel) {
    state.isLoading = true;
    if (!rootGetters.isUserSignedIn) {
      const callingCode = state.user.callingCode;
      const phone =
        state.user.phoneV2.charAt(0) == "0"
          ? state.user.phoneV2.substr(1)
          : state.user.phoneV2;
      state.user.phone = `${callingCode}${phone}`;
      // store user information to local storage
      localStorage.setItem(
        "hungryhub_booking_user",
        JSON.stringify(state.user)
      );
    }

    return new Promise((resolve, reject) => {
      try {
        const {
          adult,
          kids,
          specialRequest,
          startTime,
          selectedPackages,
          occasion,
          paymentMethod
        } = state.reservation;
        const distanceToRestaurant = state.distanceToRestaurant.value / 1000;
        const restaurantId = state.restaurant.id;

        // function for packages payload
        function buildPackagesPayload() {
          if (getters.restaurantReservationSystemOnly) {
            return [];
          } else if (selectedPackages.length === 0) {
            reject("Please select packages");
            return;
          } else {
            try {
              return selectedPackages.map(function(pack) {
                if (
                  !pack.hasOwnProperty("id") ||
                  !pack.hasOwnProperty("quantity")
                ) {
                  reject("Ops, Something went wrong. Invalid packages data");
                  Rollbar.error(
                    "Ops, Something went wrong. Invalid packages data",
                    { packages: selectedPackages }
                  );
                  return;
                }
                // check if package is hungry@home or not
                if (
                  !pack.hasOwnProperty("menuSections") ||
                  !pack.hasOwnProperty("menuQuantityLimit") ||
                  pack.menuQuantityLimit == 0
                ) {
                  return pack;
                }

                let result = {
                  id: pack.id,
                  quantity: pack.quantity,
                  menuSections: []
                };
                pack.menuSections.forEach(menuSection => {
                  if (menuSection.selectedMenu) {
                    let section = {
                      id: menuSection.id,
                      menus: []
                    };
                    // add array of selected menu
                    menuSection.selectedMenu.forEach(selectedMenu => {
                      section.menus.push({
                        id: selectedMenu.id,
                        quantity: selectedMenu.quantity
                      });
                    });
                    result.menuSections.push(section);
                  }
                });
                return result;
              });
            } catch (err) {
              Rollbar.error(
                "Ops, Something went wrong. Failed create booking",
                { cause: err }
              );
            }
          }
        }

        // function for reservation payload
        function buildReservationPayload() {
          const addDistanceToRestaurant = () => {
            return occasion == "delivery" ? distanceToRestaurant : null;
          };
          const addServiceType = () => {
            return !getters.isDineIn ? occasion : null;
          };
          const addDiningOccasionId = () => {
            return getters.isDineIn ? occasion : null;
          };

          const data = {
            diningOccasionId: addDiningOccasionId(),
            distanceToRestaurant: addDistanceToRestaurant(),
            serviceType: addServiceType(),
            date: moment(state.reservation.date).format("YYYY-MM-DD"),
            adult,
            kids,
            restaurantId,
            specialRequest,
            startTime
          };
          return omitBy(data, isNil);
        }

        // function for base payload
        function buildBasePayload() {
          // if occassion delivery add distance to restaurant
          const addAddress = () => {
            if (occasion == "delivery") {
              const address = { ...state.address };
              address.detail = `${address.placeName}, ${address.detail}`;
              return address;
            }
            return null;
          };
          const addPaymentType = () => {
            if (getters.isRequireCc) {
              return paymentMethod == "promptpay" ? "promptpay" : null;
            }
            return null;
          };
          const addAccessToken = () => {
            return rootGetters.token ? rootGetters.token : null;
          };
          const addOmiseToken = () => {
            if (getters.isRequireCc) {
              return paymentMethod != "promptpay" ? state.cc.token : null;
            }
            return null;
          };
          const addGuestUser = () => {
            if (rootGetters.isUserSignedIn === false) {
              const phone =
                state.user.phoneV2.charAt(0) == "0"
                  ? state.user.phoneV2.substr(1)
                  : state.user.phoneV2;
              state.user.phone = `${state.user.callingCode}${phone}`;
              return {
                name: state.user.name,
                email: state.user.email,
                phone: state.user.phone
              };
            }
            return null;
          };
          const addGuestAttributes = () => {
            if (
              getters.restaurantRecordGuest === true &&
              getters.isDineIn === true
            ) {
              return state.recordGuest.map(guest => {
                return {
                  name: `${guest.firstName} ${guest.lastName}`,
                  phone: `${guest.phoneCode}${guest.phone}`
                };
              });
            }
            return null;
          };

          const data = {
            address: addAddress(),
            accessToken: addAccessToken(),
            minorVersion: API_MINOR_VERSION,
            channel: channel,
            source: "website",
            provider: "hungryhub",
            bigGroup: state.isBigGroupBooking,
            omiseToken: addOmiseToken(),
            omisePaymentType: addPaymentType(),
            guestUser: addGuestUser(),
            guestsAttributes: addGuestAttributes()
          };
          // reject attributes that have null value
          return omitBy(data, isNil);
        }

        const url = `${API_BASE_URL}/${API_MAJOR_VERSION}/reservations.json`;
        const packagesPaylaod = buildPackagesPayload();
        const basePayload = { ...buildBasePayload() };
        const reservationPayload = { ...buildReservationPayload() };
        // final payload
        const payload = {
          ...basePayload,
          reservation: reservationPayload,
          packages: packagesPaylaod
        };
        postJSON(
          url,
          humps.decamelizeKeys(payload),
          r => {
            state.isLoading = false;
            const response = humps.camelizeKeys(r);
            const { message } = response;
            // booking failed
            if (response.success == false) {
              const error = {
                message: "Ops, Something went wrong, Failed create booking",
                cause: message,
                url
              };
              reject(error.cause);
            } else {
              const { id, attributes } = response.data;
              resolve({ id, attributes });
            }
          },
          err => {
            state.isLoading = false;
            const error = {
              message: "Ops, Something went wrong, Failed create booking",
              cause: err
            };
            Rollbar.error(error.message, {
              cause: error.cause,
              payload,
              url
            });
            reject(error.message);
          }
        );
      } catch (err) {
        const error = {
          message: err,
          cause: err
        };
        Rollbar.error(error.message, error.cause);
      }
    });
  }
};
